import Service from "../Service";

const resource = "approvallevels/";

export default {
    save(atg, requestID) {
        return Service.post(resource + "save", atg, {
            params: { requestID: requestID },
        });
    },
    byDocument(parameters, requestID) {
        return Service.post(resource + "byDocument", parameters, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
};